import type { BadgeTone } from '@easymoving/ui';
import type { Destination, ProgressStatus } from '@easymoving/types';

/** Solid dot colour per tone — for compact themed option/legend markers. */
export const toneDot: Record<BadgeTone, string> = {
  neutral: 'bg-graphite-soft',
  petrol: 'bg-petrol',
  clay: 'bg-clay',
  olive: 'bg-olive',
  amber: 'bg-amber',
  blue: 'bg-blue',
  violet: 'bg-violet',
  rose: 'bg-rose',
  ink: 'bg-ink',
};

/** Each destination gets a distinct, calm hue (mirrors theme palette). */
export function destinationTone(d: Destination): BadgeTone {
  switch (d) {
    case 'pack':
      return 'olive';
    case 'storage':
      return 'blue';
    case 'give_away':
      return 'rose';
    case 'sell':
      return 'violet';
    case 'donate':
      return 'petrol';
    case 'discard':
      return 'clay';
    case 'undecided':
      return 'amber';
  }
}

export function statusTone(s: ProgressStatus): BadgeTone {
  switch (s) {
    case 'not_started':
      return 'neutral';
    case 'needs_decision':
      return 'amber';
    case 'ready_to_pack':
      return 'blue';
    case 'packed':
      return 'olive';
    case 'in_storage':
      return 'blue';
    case 'completed':
      return 'petrol';
  }
}
